const iframe = () => {
  const ifameSrc = 'https://games-cv.com/hot_rio_samba',
    play = document.querySelector('#btn_iframe'),
    bg = document.querySelector('.iframe_bg'),
    iframe = document.querySelector('#iframe');
  play.addEventListener('click', evt => {
    iframe.src = ifameSrc;
    bg.classList.add('hidden');
    play.classList.add('hidden');
    iframe.classList.add('visible');
  });
};
export default iframe;
